import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './DropdownMenu.module.css';

const isExternalPath = (path) => /^https?:\/\//i.test(path);

const DropdownMenu = ({ label, items, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isAnyItemActive = items.some(
    (item) => !isExternalPath(item.path) && location.pathname === item.path
  );

  return (
    <div
      className={styles.dropdown}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className={`${styles.trigger} ${isOpen || isAnyItemActive ? styles.triggerOpen : ''} ${className || ''}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {label}
        <svg
          className={styles.arrow}
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <path
            d="M3.25 5.25L6.5 8.5L9.75 5.25"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className={styles.menu}>
          {items.map((item) =>
            isExternalPath(item.path) ? (
              <a
                key={item.path}
                href={item.path}
                className={styles.menuItem}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className={`${styles.menuItem} ${location.pathname === item.path ? styles.menuItemActive : ''}`}
              >
                {item.label}
              </Link>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
